import SendIcon from "@mui/icons-material/Send";
import { useAppDispatch } from "hooks/hooks";
import { addNewMessage, selectState } from "../chat.slice";
import { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import ChatMessage from "./ChatMessage";
import { toast } from "react-toastify";
import { chatService } from "../services/chat.service";
import "./../styles/main.scss";
import { dashboardService } from "Dashboard/services/dashboard.service";
import { setUnseenMessagesNumber } from "Dashboard/dashboard.slice";
import { authServices } from "authentication/services/auth.service";
import { IEmployeeSimple } from "Dashboard/domain/IEmployeeSimple";
import DeleteMessageModal from "./DeleteMessageModal";
import useDataFetch from "hooks/dataFetch";
import { IChatMessage } from "../domain/IChatMessage";
import Loader from "components/Loader/Loader";

interface IProps {
  setClickOutsideActive: React.Dispatch<React.SetStateAction<boolean>>;
};

const ChatTooltip = ({ setClickOutsideActive }: IProps) => {
  const { messages } = useSelector(selectState);
  const [message, setMessage] = useState("");
  const dispatch = useAppDispatch();
  const [user,] = useState<IEmployeeSimple>({
    employeeId: -1,
    name: "",
  });

  const limit = 50;
  const [afterId, setAfterId] = useState<number | undefined>(undefined);
  const [beforeId, setBeforeId] = useState<number | undefined>(undefined);
  const { data, setData, hasMoreAfter, loadingAfter, loadingBefore, hasMoreBefore } =
    useDataFetch<IChatMessage>(
      chatService.getAllEmployeeMessages,
      limit,
      afterId,
      beforeId
    );

  const observer = useRef<IntersectionObserver>();

  const lastElementRef = useCallback(
    (node: any) => {
      if (loadingAfter) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMoreAfter) {
          setAfterId(data[data.length - 1].message.messageId);
        }
      });
      if (node) observer.current.observe(node);
      console.log(node);
    },
    [data, loadingAfter, hasMoreAfter]
  );

  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    if (e.currentTarget.scrollTop === 0 && hasMoreBefore) {
      if (loadingBefore) return;
      setBeforeId(data[0].message.messageId);
    }
  };

  useEffect(() => {
    getUser();
  }, [dispatch]);

  useEffect(() => {
    let latestDate = messages
      .map((e) => {
        return e.message.dateTime;
      })
      .sort()
      .reverse()[0];
    let latestMessage = messages.find((x) => x.message.dateTime === latestDate);
    if (latestMessage !== undefined && !latestMessage.isSeen) {
      dashboardService.seeUnseenMessages(latestMessage.message.messageId);
      dispatch(setUnseenMessagesNumber(0));
    }
  }, [dispatch, messages]);

  async function getUser() {
    try {
      const user = await authServices.getCurrentUser();
      if (user.name !== null) {
        //TODO: CHECK IF EMPLOYEEID NEEDS TO BE REMOVED
        // setUser({
        //   employeeId: user,
        //   name: user.name,
        // });
      }
    } catch (error) {
      console.log(error);
    }
  }

  const clearMessageInput = () => {
    setMessage("");
  };

  const onChangeMessage = (e: any) => {
    setMessage(e.target.value);
  };

  const onSubmitMessage = async (e: any) => {
    e.preventDefault();
    try {
      if (message) {
        const dataText = { text: message };
        const response = await chatService.sendMessage(dataText);
        const newMessage: IChatMessage =
          { message: response, isSeen: true };
        setData([newMessage, ...data]);
        dispatch(addNewMessage({ message: response, isSeen: true }));
        toast.success("Poruka je uspešno poslata.");
        clearMessageInput();
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div id="chat-tooltip" onScroll={handleScroll}>
      <div className="messages-box">
        {loadingBefore && <Loader />}
        {messages &&
          data.map((message, index) => {
            const isLast = index === data.length - 1;
            return (
              <ChatMessage
                lastElementRef={isLast ? lastElementRef : undefined}
                user={user}
                message={message}
                key={`${message.message.messageId}`}
                index={index}
              />
            );
          })}
        {loadingAfter && <Loader />}
        <DeleteMessageModal setClickOutsideActive={setClickOutsideActive} />
      </div>

      <form onSubmit={onSubmitMessage} className="send-message-box">
        <input type="checkbox" className="send-message-check" />
        <input
          type="text"
          className="send-message-input"
          onChange={onChangeMessage}
          value={message || ""}
        />
        <button type="submit" className="send">
          <SendIcon fontSize="small" />
        </button>
      </form>
    </div>
  );
};

export default ChatTooltip;
